import { useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { api, describeAxiosError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";

export const UpdatePfTotalsDialog = ({ month, company, count, onClose, onSaved }) => {
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const update = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try { const { data } = await api.post("/payroll/recalculate-deductions", { month, ...(company ? { company } : {}) }); onSaved(data); }
    catch (e) { setError(describeAxiosError(e)); }
    finally { setBusy(false); }
  };
  return <AlertDialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
    <AlertDialogContent className="bg-white w-[calc(100%-2rem)] rounded-lg" data-testid="update-pf-dialog">
      <AlertDialogHeader><AlertDialogTitle data-testid="update-pf-title">Update PF totals for {month}?</AlertDialogTitle>
        <AlertDialogDescription data-testid="update-pf-description">{count} saved PF record(s) in {company ? company === "NAVARATNAA" ? "Navaratnaa" : "Sherataan" : "all companies"} need the combined PF total. Employer PF already excluded from gross will not be deducted twice. Gross salary, paid days, manual deductions, employer ESI and other months remain unchanged.</AlertDialogDescription>
      </AlertDialogHeader>
      {error && <p role="alert" className="text-sm text-red-700" data-testid="update-pf-error">{error}</p>}
      <AlertDialogFooter><AlertDialogCancel disabled={busy} data-testid="update-pf-cancel">Cancel</AlertDialogCancel><Button disabled={busy} onClick={update} data-testid="update-pf-confirm">{busy ? <Loader2 className="animate-spin" /> : <RefreshCw />}Update PF totals</Button></AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
};